import { GetTitoloAutorizzativoQuery } from '../../_graphql/generated';

export type TitoloAutorizzativo = {
  loading: boolean;
  lista: GetTitoloAutorizzativoQuery['energy_village_titolo_autorizzativo'];
  failure: any;
};

export const initialTitoloAutorizzativoState: TitoloAutorizzativo = {
  loading: false,
  lista: [],
  failure: '',
};
